import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { getGlycerinArticleId } from '@packages/modules/src/Tracking/helper/getGlycerinArticleId/getGlycerinArticleId';
import { getGlycerinAvailability } from '@packages/modules/src/Tracking/helper/getGlycerinAvailability/getGlycerinAvailability';
import { getGlycerinOrigin } from '@packages/modules/src/Tracking/helper/getGlycerinOrigin/getGlycerinOrigin';
import { GetGlycerinWishlistProductPayloadFragmentFragmentDoc } from '@packages/gql/generated/shopping/GetGlycerinWishlistProductPayloadFragmentFragmentDoc';
import type { GlycerinWishListProduct } from '@packages/tracking/src/types/types';
import { getGlycerinPrice } from '../getGlycerinPrice';

/* GraphQL */ `
  fragment GetGlycerinWishlistProductPayloadFragment on Product {
    akl
    sku
    availability {
      ...GetGlycerinAvailabilityFragment
    }
    price {
      ...GetGlycerinPriceFragment
    }
    ...GetGlycerinArticleIdFragment
  }
`;

export type GetGlycerinWishlistProductPayloadProps = {
  data: FragmentType<typeof GetGlycerinWishlistProductPayloadFragmentFragmentDoc>;
  refSearchParam: string | null;
};

export const getGlycerinWishlistProductPayload = ({
  data,
  refSearchParam,
}: GetGlycerinWishlistProductPayloadProps): GlycerinWishListProduct => {
  const unmaskedData = getFragmentData(GetGlycerinWishlistProductPayloadFragmentFragmentDoc, data);
  const { akl, sku, price, availability } = unmaskedData;

  return {
    productId: akl,
    skuId: sku,
    ...getGlycerinArticleId(unmaskedData),
    ...getGlycerinPrice(price),
    ...getGlycerinAvailability(availability),
    ...getGlycerinOrigin(refSearchParam),
    listPosition: undefined,
  };
};
